//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/LineFontBuilder.js";
let d=[[[0,"AnnotationPlane",1,0],[0,"AnnotationPlaneColor",1,0],[0,"AnnotationPlaneDisplay",1,0],[0,"AnnotationPlaneFont",0,"LineFontBuilder",0],[0,"AnnotationPlaneTranslucency",1,0],[0,"BackgroundColor",1,0],[0,"DisplayInAllViews",1,0],[0,"DisplayPmiShadedModel",1,0],[0,"EnableBackground",1,0],[0,"EnableResize",1,0],[0,"ProjectOntoPlane",1,0],[0,"ResizeOnCreate",1,0],[0,"ResizeOnViewSave",1,0],[0,"ResizeSettings",1,0],[0,"UpdateReadingDirection",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.PmiGeneralSetupDisplayBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiGeneralSetupDisplayBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PmiGeneralSetupDisplayBuilder.AnnotationPlaneType = Object.freeze({
    "XYPlaneofWCS" : "XYPlaneofWCS", "XZPlaneofWCS" : "XZPlaneofWCS", "YZPlaneofWCS" : "YZPlaneofWCS", "ModelViewPlane" : "ModelViewPlane"});

SPLM.Annotations.PmiGeneralSetupDisplayBuilder.ResizeSettingsType = Object.freeze({
    "RelativetoSavedViewScale" : "RelativetoSavedViewScale", "RelativetoViewZoomFactor" : "RelativetoViewZoomFactor", "Independently" : "Independently", "RelativetoPartPreferences" : "RelativetoPartPreferences"});

SPLM.Annotations.PmiGeneralSetupDisplayBuilder.AnnotationPlaneDisplayType = Object.freeze({
    "All" : "All", "ActivePlaneOnly" : "ActivePlaneOnly", "None" : "None"});

export default SPLM;